import { Box, Chip, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { relationshipColorMap } from '../../Contacts/data';

const renderLevel = (items: any): JSX.Element => {
  if (items.length === 0) return <></>;
  const currentLevel = items[0].levelOrder;
  const lastIndexInLevel = items.findIndex((item: any) => item.levelOrder !== currentLevel);
  const splitPoint = lastIndexInLevel === -1 ? items.length : lastIndexInLevel;

  const currentLevelItems = items.slice(0, splitPoint);
  const remainingItems = items.slice(splitPoint);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {currentLevelItems.map((item: any, i: number) => {
          const relationship = item.contactRelationship as keyof typeof relationshipColorMap;
          const isChipPresent = relationship !== 'Known';

          return (
            <Box
              key={item.name}
              sx={{
                minWidth: '200px',
                height: '90px',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '14px',
                padding: '16px',
                gap: '12px',
                overflow: 'hidden',
                border: `1px solid ${relationshipColorMap[relationship].backgroundColor}`,
              }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  textWrap: 'nowrap',
                  gap: '8px',
                }}
              >
                <Typography key={i} variant='body1'>
                  {item.name}
                </Typography>
                {isChipPresent && (
                  <Chip
                    label={
                      <Typography variant='responsiveLabel1'>{item.contactRelationship}</Typography>
                    }
                    sx={{
                      height: '22px',
                      ...relationshipColorMap[relationship],
                    }}
                  />
                )}
              </Box>
              <Typography
                sx={{
                  whiteSpace: 'nowrap',
                  textWrap: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                {item.title.split(',')[0]}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {renderLevel(remainingItems)}
    </Box>
  );
};

const OrganizationChart = ({ data }: { data: any }) => {
  if (!data) return <>No data</>;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        flex: 1,
        borderRadius: '14px',
        padding: '16px',
        overflow: 'scroll',
      }}
    >
      <Typography variant='responsiveHeading3'>Org Chart</Typography>

      {renderLevel([...data])}
    </Box>
  );
};

export default OrganizationChart;
